import Api from "../../../ApiConfig";
import ApiEndPoint from "../../../ApiEndPoints";

const baseURL = ApiEndPoint.Sewahat;
export const ProfileSetup_About = (param) => {
    const headers=param.headers
    const finalUrl = baseURL + ApiEndPoint.Profile + ApiEndPoint.About
    return Api.postData(finalUrl, headers, param, {});
};

export const deleteServiceRecord = (queryParams) => {
    const { data, headers , id} = queryParams;
    const finalUrl = baseURL + ApiEndPoint.DELETE_SERVICE_RECORD
    return Api.postData(finalUrl, headers, data,{id});
}

export const submitFeedback = (queryParams) => {
    const { data, headers , id} = queryParams;
    const finalUrl = baseURL + ApiEndPoint.SubmitFeedback
    return Api.postData(finalUrl, headers, data,{id});
}

export const ProfileSetup_Service = async (param) => {
    const { body, headers } = param
    const finalUrl = baseURL + ApiEndPoint.Profile + ApiEndPoint.Services
    const apiResponse = await Api.postData(finalUrl, headers, body.services, { id: param?.vendoreId });
    return {response: apiResponse, isSetupProfile: body.isSetupProfile};
};

export const ServicesOffered = (headers) => {
    const finalUrl = baseURL + ApiEndPoint.GetServices
    return Api.getData(finalUrl, headers, {});

}
export const GetVendorDetails = (param,header) => {
    const finalUrl = baseURL + ApiEndPoint.GetVendorById
    return Api.getData(finalUrl, header, param);

}
export const getSkillsData = (param = {},header = {}) => {
    const finalUrl = baseURL + ApiEndPoint.SKILLS_DATA
    return Api.getData(finalUrl, header, param);
}

export const addOtherSkills = (data, header) => {
    const finalUrl = baseURL + ApiEndPoint.ADD_OTHER_SKILLS
    return Api.postData(finalUrl, header, data, {});
}

export const SubmitOtherService = (params) => {
    const { body, headers} = params;
    const finalUrl = baseURL + ApiEndPoint.SUBMIT_OTHER_SERVICE
    return Api.postData(finalUrl, headers,body,{});
}

export const editOtherService = (params) => {
    const { body, headers} = params;
    const finalUrl = baseURL + ApiEndPoint.EDIT_REQUEST
    return Api.postData(finalUrl, headers,body,{});
}


export const UploadMedia = (body) => {
    const finalUrl = baseURL + ApiEndPoint.UploadMedia
    return Api.postData(finalUrl, {},body,{});

}
export const RemoveSamples =  async (params) => {
    const{headers,uploadSamples,serviceId ,  servicesuuid , body  }= params
    const finalUrl = baseURL + ApiEndPoint.RemoveSamples
    const Data = await Api.postData(finalUrl, headers,body,{serviceId:serviceId})
    return { body , serviceId, servicesuuid , data : Data , keyName : body.url ? "url" : "uploadSamples" };

}
export const RemovePancard =  async (params) => {
    const{headers,serviceId , servicesuuid}= params
    const finalUrl = baseURL + ApiEndPoint.RemovePancard
    const Data= await Api.getData(finalUrl, headers,{serviceId:serviceId})
    return { serviceId, servicesuuid , data : Data };

}



// localhost:8080/sewahat/getServices